import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import storage from './storage'

// import Auth views
import Login from '@imemento/spa-helpers/src/views/auth/Login'
import RecoverPassword from '@imemento/spa-helpers/src/views/auth/RecoverPassword'
import Register from '@imemento/spa-helpers/src/views/auth/Register'
import ResetPassword from '@imemento/spa-helpers/src/views/auth/ResetPassword'
import InsufficientPrivileges from '@imemento/spa-helpers/src/views/auth/InsufficientPrivileges'

// import Auth views
import Places from './views/Places.vue'
import Articles from './views/Articles'
import Comments from './views/Comments.vue'
import Photos from './views/Photos.vue'
import StaticPages from './views/StaticPages.vue'
import Translations from './views/Translations.vue'
import Platforms from './views/Platforms.vue'
import Languages from './views/Languages.vue'

// import Healthy view
import Healthy from '@imemento/spa-helpers/src/views/healthy/Healthy'

// the router instance
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/authentication/login',
      component: Login,
      meta: { private_route: false }
    },
    {
      path: '/authentication/recover-password',
      component: RecoverPassword,
      meta: { private_route: false }
    },
    {
      path: '/authentication/register',
      component: Register,
      meta: { private_route: false }
    },
    {
      path: '/authentication/reset-password',
      component: ResetPassword,
      meta: { private_route: false }
    },
    {
      path: '/authentication/insufficient-privileges',
      component: InsufficientPrivileges,
      meta: { private_route: false }
    },
    {
      path: '/healthy',
      component: Healthy,
      meta: { private_route: false }
    },
    {
      path: '/',
      redirect: '/articles'
    },
    {
      path: '/places',
      component: Places,
      meta: { private_route: true }
    },
    {
      path: '/articles',
      component: Articles,
      meta: { private_route: true }
    },
    {
      path: '/comments',
      component: Comments,
      meta: { private_route: true }
    },
    {
      path: '/photos',
      component: Photos,
      meta: { private_route: true }
    },
    {
      path: '/translations',
      component: Translations,
      meta: { private_route: true }
    },
    {
      path: '/static-pages',
      component: StaticPages,
      meta: { private_route: true }
    },
    {
      path: '/platforms',
      component: Platforms,
      meta: { private_route: true }
    },
    {
      path: '/languages',
      component: Languages,
      meta: { private_route: true }
    }
  ]
});

// router before middleware
router.beforeEach(async (to, from, next) => {

  if (to.path === '/healthy') {
    return next();
  }

  let token = await storage.getToken();
  let roles = await storage.getRoles();

  if (!token && to.meta.private_route) {
    return next('/authentication/login');
  }

  if ((!roles || !roles.spa_content_manager ||!roles.spa_content_manager.includes('admin')) && to.meta.private_route) {
    return next('/authentication/insufficient-privileges');
  }

  return next();
});

export default router;
